import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {HolidaySearchFilterService} from '../../services/holiday-search-filter.service';
import {Pagination} from '../../../../../shared/interfaces/pagination';

@Component({
  selector: 'app-holiday-search-pagination',
  templateUrl: './holiday-search-pagination.component.html',
  styleUrls: ['./holiday-search-pagination.component.scss']
})
export class HolidaySearchPaginationComponent implements OnInit {

  constructor(private _holidaySearchFilterService: HolidaySearchFilterService) { }
  @Output() pageChange = new EventEmitter<number>();

  pagination: Pagination;

  ngOnInit(): void {
    this.pagination = this._holidaySearchFilterService.pagination;
  }

  onPageChange($event): void {
    this.pageChange.emit($event);
  }

}
